import * as angular from 'angular';
import { TooltipState } from './tooltip-state';
import { OperationService } from '../../operation.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { StateService } from '@uirouter/core';
import { IImportResult } from '../../models';
import { EnumService } from '../../../../../app.common/modules/common/services/enum.service';
import { ProductsService } from '../../../products/products.service';

class ImportTabComponent implements ng.IComponentController {
    static readonly $inject = ['productsService', 'enumService', 'operationService', 'notificationService', '$q', '$translate', '$state'];

    tooltipState: TooltipState = TooltipState.None;
    tooltipMessage: string;
    waiting: boolean;
    errors: IImportResult;
    uploadPromise: ng.IPromise<void>;

    hasArchivedProducts: boolean;

    private fileInput: HTMLInputElement;
    private inputDefer: ng.IDeferred<File>;
    private uploadDefer: ng.IDeferred<void>;

    constructor(
        private readonly productsService: ProductsService,
        private readonly enumService: EnumService,
        private readonly operationService: OperationService,
        private readonly notificationService: NotificationService,
        private readonly $q: ng.IQService,
        private readonly $translate: angular.translate.ITranslateService,
        private readonly $state: StateService) {
            this.uploadDefer = $q.defer();
            this.uploadPromise = this.uploadDefer.promise;
    }

    $onInit() {
        this.fileInput = <HTMLInputElement>angular.element('#input')[0];

        this.productsService.isExistProducts(this.enumService.PhysicalProductState.Archived)
            .then((response) => this.hasArchivedProducts = response);
    }

    $onDestroy() {
        this.uploadDefer.reject();
        if (this.inputDefer) {
            this.inputDefer.reject();
        }
    }

    goToHelp() {
        this.$state.go('app.help.manual');
    }

    goToProducts(state: number) {
        this.$state.go('app.products', { state: state });
    }

    selectFile(replaceExisting: boolean) {
        if (this.inputDefer) {
            this.inputDefer.reject();
        }

        this.inputDefer = this.inputToDefer(this.fileInput);
        this.inputDefer.promise
            .then(file =>
                this.uploadFile(file, replaceExisting))
            .then(() =>
                 this.fileInput.value = '')
            .catch(angular.noop);

        this.fileInput.click();
    }

    uploadFile(file: File, replaceExisting: boolean) {
        this.notificationService.clearAll();

        this.tooltipMessage = this.$translate.instant('uploading_file_tooltip', { fileName: file.name });
        this.tooltipState = TooltipState.Loading;
        this.waiting = true;
        this.errors = null;

        this.operationService.importFile(file, replaceExisting)
            .then((response) => {
                this.errors = response;
                if (response.Success) {
                    this.tooltipState = TooltipState.Done;
                    this.tooltipMessage = this.$translate.instant('file_uploaded_tooltip', { fileName: file.name});
                    this.uploadDefer.notify(response.OperationModel);
                    return response;
                }

                this.tooltipState = TooltipState.None;
                this.notificationService.showErrorMessage('Errors occurred during importing');
                return response;
            })
            .finally(() => this.waiting = false)
            .catch(e => {
                this.notificationService.showErrorMessage(e);
                this.errors = null;
                this.tooltipState = TooltipState.None;
            });
    }

    private inputToDefer(input: HTMLInputElement): ng.IDeferred<File> {
        let deferred = this.$q.defer<File>();

        input.addEventListener('change', onInputChanged);
        deferred.promise
            .catch(angular.noop)
            .finally(() => input.removeEventListener('change', onInputChanged));

        return deferred;

        function onInputChanged() {
            deferred.resolve(input.files[0]);
        }
    }
}

angular
    .module('naut')
    .component('importTab', {
        controller: ImportTabComponent,
        template: require('./import-tab.component.html')
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/components/import-tab/import-tab.component.ts